export default "__VITE_ASSET__DOpOQAyl__"